import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Modal, Icon, IconTypes, IconColor } from '@app/ui'
import { ModalType } from '@app/types'

interface SuccessModalProps {
  open: boolean
  onClose: () => void
  title: string
  highlightedText?: string
  description: string
  bottomContent?: ReactNode
}

const SuccessModal: FC<SuccessModalProps> = ({
  open,
  onClose,
  title,
  highlightedText,
  description,
  bottomContent,
}) => {
  return (
    <StyledModal open={open} type={ModalType.standard} onClose={onClose}>
      <ModalContent>
        <CheckIconWrapper>
          <Icon
            type={IconTypes.circleCheck}
            width={48}
            height={48}
            color={IconColor.viloet400}
          />
        </CheckIconWrapper>

        <Title>{title}</Title>
        {highlightedText && <HighlightedText>{highlightedText}</HighlightedText>}
        <Description>{description}</Description>

        {bottomContent && <BottomContent>{bottomContent}</BottomContent>}
      </ModalContent>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
    z-index: 10000 !important;

  .type-standard {
    background: linear-gradient(180deg, rgba(24, 24, 27, 0.95) 0%, rgba(24, 24, 27, 0.98) 100%);
    border: 1px solid rgba(var(--violet-500-rgb), 0.3);
    border-radius: 16px;
    max-width: 400px;
    margin: 0 16px;
    padding: 0 !important;
  }

  .modal-content {
    padding: 0;
    padding: 0 !important;

  }
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 12px 12px 12px;
  background: radial-gradient(ellipse 50% 45% at 50% 0%, var(--violet-900) 0%, transparent 100%);
`

const CheckIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 35px;
`

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 4px;
`

const HighlightedText = styled.p`
  font-size: var(--font-size-big);
  font-weight: 500;
  font-style: italic;
  color: var(--violet-200, var(--violet-400));
  text-align: center;
  margin-bottom: 10px;
`

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: var(--text-tertiary);
  text-align: center;
  line-height: 1.5;
  margin-bottom: 24px;
`

const BottomContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export default SuccessModal
